<template>
    <div class="tco-tool__comparison-card-container" :class="{'tco-tool__comparison-card-container--electric': isElectric}"
        v-if="selectedModel && selectedTrim && selectedVehicle">
        <div class="tco-tool__comparison-card-img-container">
            <img src="/images/configurator/stellantis-starburst.svg" alt="Stellantis Starburst" class="img-responsive tco-tool__starburst">
            <picture>
                <source :srcset="imageWebp" type="image/webp">
                <img :srcset="image" :alt="titleToUse" class="img-responsive tco-tool__comparison-card-img">
            </picture>
        </div>
        <div class="tco-tool__comparison-card rd-card">
            <div class="tco-tool__swiper-container" v-if="paintOptionsLength > 0">
                <div class="tco-tool__swiper-btn tco-tool__swiper-prev" ref="swiper-prev"></div>
                <div class="swiper tco-tool__swiper" ref="colorPicker">
                    <div class="swiper-wrapper">
                        <button type="button" @click="setSelectedPaint(paint)" v-for="paint in paintOptions" :key="'paint-' + paint.id" class="swiper-slide tco-tool__paint-btn" :class="{'tco-tool__paint-btn--active': selectedPaint.id == paint.id}">
                            <div class="tco-tool__paint-btn-inner" :style="'background-color: ' + paint.primary_hex"></div>
                        </button>
                    </div>
                </div>
                <div class="tco-tool__swiper-btn tco-tool__swiper-next" ref="swiper-next"></div>
            </div>
            <h2 class="tco-tool__comparison-card-h2">{{ titleToUse }}</h2>
            <h3 class="tco-tool__comparison-card-h3">{{ selectedTrim.trim }} {{ selectedVehicle.version }}</h3>
            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--1">
                <span>Vehicle OTR Price
                    <svg class="tco-tool__info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" @click="showOTRPopup = !showOTRPopup">
                        <g fill="#0293d6">
                            <path d="m165 0c-90.981 0-165 74.02-165 165s74.019 165 165 165 165-74.018 165-165-74.019-165-165-165zm0 300c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.562 135 135-60.561 135-135 135z"/>
                            <path d="m165 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991s19.996-8.968 19.996-19.991c0-11.033-8.97-20.009-19.996-20.009z"/>
                            <path d="m165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15s15-6.716 15-15v-90c0-8.284-6.716-15-15-15z"/>
                        </g>
                    </svg>
                </span>
                <span class="tco-tool__comparison-card-value">{{ price }}</span>
            </div>
            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--2 tco-tool__comparison-card-item--finance">
                <div class="tco-tool__comparison-card-finance-values">
                    <span>Monthly finance payment</span>
                    <span v-if="!financeLoading && quote" class="tco-tool__comparison-card-value">{{ monthlyPaymentFormatted }}</span>
                    <div class="tco-tool__comparison-card-value relative" v-else>
                        <img src="/images/shared/Robins-And-Day-Loader-Purple.svg" alt="Loading" class="loading-icon__icon tco-tool__finance-loading" >
                    </div>
                </div>
                <template v-if="!financeLoading && quote">
                    <div class="tco-tool__comparison-card-apr"><strong>{{ apr }}% APR</strong> Representative</div>
                    <button class="btn--fake-link tco-tool__comparison-card-quote" @click="showFinanceQuote = true" type="button">View personal quote</button>
                </template>
            </div>


            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--3" v-if="eitherVehiclesHaveServicePlanCost">
                <span v-if="serviceMaintenanceAndRepairs">{{ selectedVehicle.service_plan_years }} Year Service Plan</span>
                <span v-else>Service Plan</span>
                <span class="tco-tool__comparison-card-value" v-if="serviceMaintenanceAndRepairs === false">-</span>
                <span class="tco-tool__comparison-card-value" v-else>{{ serviceMaintenanceAndRepairsFormatted }}</span>
            </div>

            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--4">
                <span>Guaranteed Future Value</span>
                <span class="tco-tool__comparison-card-value" v-if="gfv > 0">{{ gfvFormatted }}</span>
                <span class="tco-tool__comparison-card-value" v-else>-</span>
            </div>

            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--5">
                <div class="tco-tool__comparison-card-item-triple">
                    <span>
                        <template v-if="isElectric">Estimated Electricity Cost</template>
                        <template v-else>Estimated Fuel Cost</template>
                        <svg class="tco-tool__info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" @click="showFuelPopup = !showFuelPopup">
                            <g fill="#0293d6">
                                <path d="m165 0c-90.981 0-165 74.02-165 165s74.019 165 165 165 165-74.018 165-165-74.019-165-165-165zm0 300c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.562 135 135-60.561 135-135 135z"/>
                                <path d="m165 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991s19.996-8.968 19.996-19.991c0-11.033-8.97-20.009-19.996-20.009z"/>
                                <path d="m165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15s15-6.716 15-15v-90c0-8.284-6.716-15-15-15z"/>
                            </g>
                        </svg>
                    </span>

                    <button type="button" class="tco-tool__comparison-card-link btn btn--fake-link" v-if="isElectric" @click="togglePersonalFuelUsage">Personalise <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{'tco-tool__comparison-card-link-icon': true, 'tco-tool__comparison-card-link-icon--open': showPersonaliseFuelUsage}"><path d="M0.99993 1.3941L4.39404 4.78821L7.78816 1.3941" stroke="#FFFFFF" stroke-width="2"/></svg></button>

                    <span class="tco-tool__comparison-card-value" v-if="monthlyFuelCostInPence > 0">{{ monthlyFuelCostFormatted }}</span>
                    <span class="tco-tool__comparison-card-value" v-else>-</span>
                </div>

                <div class="tco-tool__comparison-card-slider tco-tool__slider-container tco-tool__slider-container--green" v-if="isElectric" v-show="showPersonaliseFuelUsage">
                    <div class="tco-tool__slider-label-container">
                        <div class="tco-tool__slider-label">How often do you plan to charge your vehicle at home?</div>
                        <div class="tco-tool__slider-value tco-tool__slider-value--white">{{ percentChargedAtHome }}%</div>
                    </div>
                    <div ref="fuel-cost-slider"></div>
                </div>
                <div v-else class="tco-tool__comparison-card-spacer"></div>
            </div>

            <!-- <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--1">
                <span>Total cost for the duration of the contract</span>
                <span class="tco-tool__comparison-card-value" v-if="totalAmountOfCharges > 0">{{ totalAmountOfChargesFormatted }}</span>
                <span class="tco-tool__comparison-card-value" v-else>-</span>
            </div> -->

            <!-- <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--1">
                <span>Clean air zone costs</span>
                <span class="tco-tool__comparison-card-value">{{ cleanAirZoneCostFormatted }}</span>
            </div> -->

            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--6">
                <span>Road tax cost</span>
                <span class="tco-tool__comparison-card-value">{{ roadTaxFormatted }}</span>
            </div>

            <div class="tco-tool__comparison-card-item tco-tool__comparison-card-item--7" :class="{'tco-tool__comparison-card-item--hidden': !isElectric}">
                <span>
                    My {{ brand.manufacturer }} app subscription
                    <svg class="tco-tool__info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" @click="showAppSubscriptionPopup = !showAppSubscriptionPopup">
                        <g fill="#0293d6">
                            <path d="m165 0c-90.981 0-165 74.02-165 165s74.019 165 165 165 165-74.018 165-165-74.019-165-165-165zm0 300c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.562 135 135-60.561 135-135 135z"/>
                            <path d="m165 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991s19.996-8.968 19.996-19.991c0-11.033-8.97-20.009-19.996-20.009z"/>
                            <path d="m165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15s15-6.716 15-15v-90c0-8.284-6.716-15-15-15z"/>
                        </g>
                    </svg>
                </span>
                <span class="tco-tool__comparison-card-value" v-if="isElectric">{{ appSubscriptionCostFormatted }}</span>
                <span class="tco-tool__comparison-card-value" v-else>-</span>
            </div>

            <div class="tco-tool__comparison-card-total">
                <span>Total cost of ownership - {{ durationFormatted }}</span>
                <span class="tco-tool__comparison-card-total-value">{{ totalCostOver3YearsFormatted }}</span>
            </div>

            <div class="tco-tool__comparison-card-total" v-if="isElectric && totalSavings > 0">
                <span>Total savings based on your selection</span>
                <span class="tco-tool__comparison-card-total-value">{{ totalSavingsFormatted }}</span>
            </div>
            <div class="tco-tool__comparison-card-total" v-else>
                <span></span>
                <span class="tco-tool__comparison-card-total-value"></span>
            </div>

            <div v-if="enquireNowLink">
                <a :href="enquireNowLink" @click="customEvent('TCO', 'Clicked', 'Enquire Now CTA')" class="btn btn--primary btn--full-width-xs">Enquire Now</a>
            </div>
        </div>

        <Modal :open="showOTRPopup" :is-dismissed-on-click-backdrop="true" v-on:close="showOTRPopup = false" :is-card="true" :narrow="true" :showCloseIcon="true">
            <template v-slot:header>
                <h2 class="h2--m-b">Vehicle OTR Price</h2>
            </template>
            <template v-slot:body>
                'On the Road’ Price includes registration plates and delivery to your local Stellantis &You UK dealership (including VAT), 12 months’ Vehicle Excise Duty and new a vehicle registration fee of £55. Excludes fuel and insurance.
            </template>
        </Modal>

        <Modal :open="showFuelPopup" :is-dismissed-on-click-backdrop="true" v-on:close="showFuelPopup = false" :is-card="true" :narrow="true" :showCloseIcon="true">
            <template v-slot:header>
                <h2 class="h2--m-b" v-if="isElectric">Estimated Electricity Cost</h2>
                <h2 class="h2--m-b" v-else>Estimated Fuel Cost</h2>
            </template>
            <template v-slot:body>
                <div>
                    <p>Your estimated monthly fuel and electric costs are based on {{ mileageFormatted }} per year, using current average fuel prices of {{ fuelCostIce }}p per litre and electricity prices of {{ kwhCostInPence }}p per kwh when using an on street charger and {{ kwhHomeCostInPence }}p when home charging. These costs are a guide only and may change over time.</p>
                    <p>Actual fuel and energy costs may vary depending on factors like driving style, tyre pressure, load, climate control use, fuel type, and road conditions.</p>
                </div>
            </template>
        </Modal>

        <Modal :open="showFinanceQuote" :is-dismissed-on-click-backdrop="true" v-on:close="showFinanceQuote = false" :is-card="true" :narrow="false" :showCloseIcon="true">
            <template v-slot:body>
                <div class="tco-finance-calculator__finance-card">
                    <h3 class="tco-finance-calculator__quote-title">Your Quote</h3>

                    <div class="tco-finance-calculator__card-item" v-for="(item, index) in quoteAsArrayToRender" :key="index">
                        <span class="tco-finance-calculator__card-item-label" v-html="item.title"></span>
                        <span class="tco-finance-calculator__card-item-value" v-html="item.value"></span>
                    </div>
                    <div class="tco-finance-calculator__terms" v-if="quoteAsArrayToRender">
                        ^This quote is valid for a maximum of 14 days from <i>{{ quoteValidDate }} and may be withdrawn without notice</i>. Finance subject to status and age limitations. Stellantis Financial Services UK Limited RH1 1QA. <b>Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a broker not a lender and will introduce you to a limited number of lenders.</b> <a href="/terms-and-conditions" target="_blank">Ts and Cs apply</a>
                        <template v-if="selectedVehicle.brand == 'peugeot' && dealerDepCon > 0">*Peugeot part exchange boost is applied to the purchasing vehicle and will be applied on cash or finance.  To receive the boost you must part exchange a vehicle.</template>
                    </div>
                </div>
            </template>
        </Modal>

        <Modal :open="showAppSubscriptionPopup" :is-dismissed-on-click-backdrop="true" v-on:close="showAppSubscriptionPopup = false" :is-card="true" :narrow="false" :showCloseIcon="true">
            <template v-slot:header>
                <h2 class="h2--m-b">My {{ brand.manufacturer }} app subscription</h2>
            </template>
            <template v-slot:body>
                <p>The connected services app elevates your driving experience with enhanced safety, convenience, and entertainment on every journey. The quoted price reflects the total cost of the app subscription, excluding navigation, over the duration of your agreement.</p>
            </template>
        </Modal>
    </div>
</template>

<script>
import Swiper, {Navigation} from "swiper";
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import { format } from 'date-fns';
import NumberFormat from '../../../../used-vue/api/NumberFormat';
import LoadingSpinner from '../../../../core/components/LoadingSpinner.vue';
import Modal from '../../../../core/components/Modal.vue';
import { getGovernmentGrant, getFirstFee, getDepositContribution, getDepositContributionExcludingDealer, getDealerDepositContribution, getFinalPayment, getRoadsideAssistance, getPayments, getFinanceNameFromKey } from '../../../../new-vue/api/finance/finance-helpers';
import FormatWarranty from '../../../../used-vue/api/FormatWarranty';
import axios from "axios";
import noUiSlider from "nouislider";
import { customEvent } from "../../../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        LoadingSpinner,
        Modal
    },
    props: {
        isElectric: {
            required: false,
            default: false,
        },
        term: {
            required: true,
        },
        deposit: {
            required: true,
        },
        mileage: {
            required: true,
        },
        brand: {
            required: true
        },
        enquireNowLink: {
            required: false,
            default: null,
        },
        // cleanAirZoneCost: {
        //     required: true
        // },
    },
    data() {
        return {
            financeLoading: true,
            quote: null,
            monthlyPayment: null,
            apr: null,
            showOTRPopup: false,
            showFuelPopup: false,
            showFinanceQuote: false,
            showPersonaliseFuelUsage: false,
            percentChargedAtHome: 70,
            fuelCostSlider: null,
            showAppSubscriptionPopup: false,
        };
    },
    watch: {
        selectedVehicle: function (newVehicle, oldVehicle) {
            this.setupColourPickerSwiper();
            this.calculateFinance();
            this.$nextTick(() => {
                this.setupFuelCostSlider();
                this.$emit('match-height');
            });
        },
        term: function (newVehicle, oldVehicle) {
            this.calculateFinance();
        },
        deposit: function (newVehicle, oldVehicle) {
            this.calculateFinance();
        },
        mileage: function (newVehicle, oldVehicle) {
            this.calculateFinance();
        },
    },
    computed: {
        ...mapState([
            'selectedEvModel',
            'selectedIceModel',
            'selectedEvTrim',
            'selectedIceTrim',
            'selectedEvVehicle',
            'selectedIceVehicle',
            'selectedEvPaint',
            'selectedIcePaint',
            'evTotalCost',
            'iceTotalCost',
        ]),
        selectedModel() {
            if (this.isElectric) {
                return this.selectedEvModel;
            }
            return this.selectedIceModel;
        },
        selectedTrim() {
            if (this.isElectric) {
                return this.selectedEvTrim;
            }
            return this.selectedIceTrim;
        },
        selectedVehicle() {
            if (this.isElectric) {
                return this.selectedEvVehicle;
            }
            return this.selectedIceVehicle;
        },
        titleToUse() {
            if (this.isElectric) {
                if (!this.selectedModel.electric_model_title) {
                    return this.selectedModel.short_name;
                }

                return this.selectedModel.electric_model_title;
            }

            return this.selectedModel.short_name;
        },
        price() {
            return '£' + NumberFormat(this.selectedVehicle.pricing_display_price);
        },
        monthlyPaymentFormatted() {
            return '£' + NumberFormat(this.monthlyPayment);
        },
        eitherVehiclesHaveServicePlanCost() {
            if (this.selectedEvVehicle && this.selectedEvVehicle.service_plan_cost !== null) {
                const evCost = parseFloat(this.selectedEvVehicle.service_plan_cost);
                if (evCost < 10000) {
                    return true;
                }
            }
            if (this.selectedIceVehicle && this.selectedIceVehicle.service_plan_cost !== null) {
                const iceCost = parseFloat(this.selectedIceVehicle.service_plan_cost);
                if (iceCost < 10000) {
                    return true;
                }
            }
            return false;
        },
        serviceMaintenanceAndRepairs() {
            if (this.selectedVehicle.service_plan_cost === null) {
                return false;
            }
            if (this.selectedVehicle.service_plan_years === null) {
                return false;
            }

            const cost = parseFloat(this.selectedVehicle.service_plan_cost);
            if (cost > 10000) {
                return false;
            }
            return cost;
        },
        serviceMaintenanceAndRepairsFormatted() {
            return '£' + NumberFormat(this.serviceMaintenanceAndRepairs);
        },
        financePrice() {
            if (this.selectedVehicle.price_PCP > 0) {
                return this.selectedVehicle.price_PCP;
            }
            return this.selectedVehicle.pricing_display_price;
        },
        gfv() {
            if (this.financeLoading) {
                return;
            }
            if (!this.quote) {
                return;
            }
            if (typeof this.quote.Quote.FinalPayment == 'undefined') {
                return;
            }
            return this.quote.Quote.FinalPayment;
        },
        gfvFormatted() {
            return '£' + NumberFormat(this.gfv);
        },
        monthlyMileage() {
            if (!this.mileage) {
                return 0;
            }
            return this.mileage / 12;
        },
        mileageFormatted() {
            if (!this.mileage) {
                return '0 miles';
            }

            if (this.mileage == 1) {
                return '1 mile';
            }

            return NumberFormat(this.mileage, 0) + ' miles';
        },
        fuelCostIce() {
            if (!this.selectedIceVehicle) {
                return 161;
            }
            const fuel = this.selectedIceVehicle.fuel_type.toLowerCase();
            if (fuel.includes('diesel')) {
                return 182;
            }
            return 161;
        },
        kwhHomeCostInPence() {
            return 8;
        },
        kwhCostInPence() {
            return 54;
        },
        monthlyFuelCostInPence() {
            if (!this.monthlyMileage) {
                return;
            }

            if (this.isElectric) {
                if (!this.selectedVehicle.kwh_per_mile) {
                    return;
                }
                const percentChargedAtHomeAsDecimal = this.percentChargedAtHome / 100;
                const percentChargedElsewhere = 1 - percentChargedAtHomeAsDecimal;
                return (this.monthlyMileage * this.selectedVehicle.kwh_per_mile * this.kwhHomeCostInPence * percentChargedAtHomeAsDecimal) + (this.monthlyMileage * this.selectedVehicle.kwh_per_mile * this.kwhCostInPence * percentChargedElsewhere);
            }

            if (!this.selectedVehicle.mpg_combined) {
                return;
            }

            return (this.monthlyMileage / this.selectedVehicle.mpg_combined) * 4.54609 * this.fuelCostIce;
        },
        monthlyFuelCostFormatted() {
            const term = (this.term > 0) ? this.term : 12;
            return '£' + NumberFormat((this.monthlyFuelCostInPence * term) / 100, 2);
        },
        // totalAmountOfCharges() {
        //     if (this.financeLoading) {
        //         return;
        //     }
        //     if (!this.quote) {
        //         return;
        //     }
        //     if (typeof this.quote.Quote.TotalAmountOfCharges == 'undefined') {
        //         return;
        //     }
        //     return this.quote.Quote.TotalAmountOfCharges;
        // },
        // totalAmountOfChargesFormatted() {
        //     if (!this.totalAmountOfCharges) {
        //         return;
        //     }
        //     return '£' + NumberFormat(this.quote.Quote.TotalAmountOfCharges, 2);
        // },
        // cleanAirZoneCostFormatted() {
        //     if (this.isElectric) {
        //         return '£0';
        //     }
        //     return '£' + NumberFormat(this.cleanAirZoneCost);
        // },
        yearsRoundedUp() {
            const term = (this.term > 0) ? this.term : 12;
            return Math.round((term > 0) ? term / 12 : 1);
        },
        roadTax() {
            return (parseFloat(this.selectedVehicle.registration_fee) + ((this.yearsRoundedUp - 1) * parseFloat(this.selectedVehicle.tax)));
        },
        roadTaxFormatted() {
            return '£' + NumberFormat(this.roadTax);
        },
        appSubscriptionCost() {
            if (!this.isElectric) {
                return false;
            }
            if (this.selectedEvVehicle.brand == 'citroen') {
                return 59.5 * this.yearsRoundedUp;
            }
            return 84.9 * this.yearsRoundedUp;
        },
        appSubscriptionCostFormatted() {
            if (this.appSubscriptionCost === false) {
                return '-';
            }
            return '£' + NumberFormat(this.appSubscriptionCost);
        },
        totalCostOfFinance() {
            if (this.financeLoading) {
                return;
            }
            if (!this.quote) {
                return;
            }
            if (typeof this.quote.Quote.TotalAmountPayableExcludingContributions != 'undefined') {
                return this.quote.Quote.TotalAmountPayableExcludingContributions;
            }
            if (typeof this.quote.Quote.TotalAmountPayable != 'undefined') {
                return this.quote.Quote.TotalAmountPayable;
            }
            return;
        },
        durationFormatted() {
            return FormatWarranty(this.term, '');
        },
        totalCostOver3Years() {
            let total = 0;
            const term = (this.term > 0) ? this.term : 12;
            total += term * this.monthlyPayment;
            total += this.serviceMaintenanceAndRepairs;
            total += (this.monthlyFuelCostInPence * term) / 100;
            // total += this.gfv;
            if (!this.isElectric) {
                // total += this.cleanAirZoneCost * years;
            } else {
                // My Peugeot app subscription
                total += this.appSubscriptionCost;
            }
            total += this.roadTax;

            if (this.isElectric) {
                this.$store.commit('setEvTotalCost', total);
            } else {
                this.$store.commit('setIceTotalCost', total);
            }

            return total;
        },
        totalCostOver3YearsFormatted() {
            return '£' + NumberFormat(this.totalCostOver3Years);
        },
        totalSavings() {
            if (this.evTotalCost <= 0) {
                return false;
            }
            if (this.iceTotalCost <= 0) {
                return false;
            }
            if (this.isElectric) {
                return this.iceTotalCost - this.evTotalCost;
            }
            return this.evTotalCost - this.iceTotalCost;
        },
        totalSavingsFormatted() {
            return '£' + NumberFormat(this.totalSavings);
        },
        governmentGrant() {
            return getGovernmentGrant(this.quote);
        },
        longFinanceName() {
            return getFinanceNameFromKey(this.selectedVehicle, this.quote.Key, false);
        },
        dealerDepCon() {
            if (this.quote) {
                return getDealerDepositContribution(this.quote);
            }
            return 0;
        },
        quoteValidDate() {
            return format(new Date(), 'Do MMM YYYY');
        },
        quoteAsArrayToRender() {
            if (!this.quote) {
                return [];
            }
            if (!this.selectedVehicle) {
                return [];
            }
            if (this.quote.Key != 'PCP') {
                return [];
            }

            if (this.quote.HasError) {
                return [];
            }

            const payments = getPayments(this.quote);

            let outputArray = [];

            payments.forEach(payment => {
                outputArray.push({
                    title: '<span class="tco-finance-calculator__monthly-payment">' + payment.quantity + ' Monthly</span> Payments',
                    emailTitle: payment.quantity + ' Monthly Payments',
                    value: '&pound;' + NumberFormat(payment.amount, 2)
                });
            });

            outputArray.push({
                title: 'Customer Cash Deposit',
                value: '&pound;' + NumberFormat(this.quote.Quote.CashDeposit, 2)
            });

            const firstFee = getFirstFee(this.quote);
            const depCon = getDepositContribution(this.quote);
            const depConExcludingDealer = getDepositContributionExcludingDealer(this.quote);

            const finalPayment = getFinalPayment(this.quote);
            const roadsideAssistance = getRoadsideAssistance(this.quote);

            if (this.selectedVehicle.brand == 'peugeot' && this.dealerDepCon > 0) {
                outputArray.push({
                    title: 'Part Exchange Boost*',
                    value: '&pound;' + NumberFormat(this.dealerDepCon, 2)
                });
                if (depConExcludingDealer > 0) {
                    outputArray.push({
                        title: this.depConName,
                        value: '&pound;' + NumberFormat(depConExcludingDealer, 2)
                    });
                }
            } else if (depCon > 0) {
                outputArray.push({
                    title: this.depConName,
                    value: '&pound;' + NumberFormat(depCon, 2)
                });
            }

            outputArray = this.appendVehiclePricingIncludingApplicableGrants(outputArray);

            if (this.selectedVehicle.brand !== 'vauxhall') {
                outputArray.push({
                    title: this.longFinanceName + ' Price <span class="tco-finance-calculator__small-label">Including &pound;' + roadsideAssistance + ' Roadside Assistance</span>',
                    emailTitle: this.longFinanceName + ' Price - Including &pound;' + roadsideAssistance + ' Roadside Assistance',
                    value: '&pound;' + NumberFormat(this.quote.Quote.TotalPrice, 2)
                });
            }

            outputArray.push({
                title: 'Amount Financed',
                value: '&pound;' + NumberFormat(this.quote.Quote.Balance, 2)
            });

            outputArray.push({
                title: 'Optional Final Payment To Buy',
                value: '&pound;' + NumberFormat(finalPayment, 2)
            });

            outputArray.push({
                title: 'Credit Facility Fee <span class="tco-finance-calculator__small-label">Payable With 1st Payment</span>',
                emailTitle: 'Credit Facility Fee - Payable With 1st Payment',
                value: '&pound;' + NumberFormat(firstFee, 2)
            });

            outputArray.push({
                title: 'Term Of Agreement',
                value: this.quote.Quote.Term + ' months'
            });

            outputArray.push({
                title: 'Total Charge For Credit',
                value: '&pound;' + NumberFormat(this.quote.Quote.TotalChargeForCredit, 2)
            });

            outputArray.push({
                title: 'Total Amount Of Credit',
                value: '&pound;' + NumberFormat(this.quote.Quote.AmountOfCredit, 2)
            });

            outputArray.push({
                title: 'Total Amount Payable',
                value: '&pound;' + NumberFormat(this.quote.Quote.TotalAmountPayable, 2)
            });

            outputArray.push({
                title: 'Fixed Rate of Interest',
                value: NumberFormat(this.quote.Quote.RateOfInterest, 2) + '%'
            });

            if (this.financeModified) {
                outputArray.push({
                    title: 'APR',
                    value: NumberFormat(this.quote.Quote.Apr, 2) + '%'
                });
            } else {
                outputArray.push({
                    title: 'Representative APR',
                    value: NumberFormat(this.quote.Quote.Apr, 2) + '%'
                });
            }

            outputArray.push({
                title: 'Excess Mileage Charge',
                value: ' ' + NumberFormat(this.quote.Quote.ExcessMileageRate,0) + ' pence per mile'
            });

            outputArray.push({
                title: 'Annual Mileage',
                value: ' ' + NumberFormat(this.quote.Quote.AnnualMileage,0) + '  miles'
            });

            return outputArray;
        },
        paintOptionsLength() {
            return this.paintOptions.length;
        },
        paintOptions() {
            if (!this.selectedVehicle) {
                return [];
            }
            if (!this.selectedVehicle.new_vehicle_paint_options) {
                return [];
            }
            return this.selectedVehicle.new_vehicle_paint_options;
        },
        selectedPaint() {
            if (!this.selectedVehicle) {
                return null;
            }
            if (this.paintOptionsLength == 0) {
                return null;
            }
            if (this.isElectric) {
                return this.selectedEvPaint;
            }
            return this.selectedIcePaint;
        },
        image() {
            if (!this.selectedPaint) {
                return '/images/tco/image-coming-soon@1x.jpg, /images/tco/image-coming-soon@2x.jpg 2x';
            }
            return 'https://cdn.imagin.studio/getImage?customer=robinsandday&zoomType=fullscreen&steering=right&width=800&angle=01&fileType=webp&' + this.selectedPaint.url_identifier;
        },
        imageWebp() {
            if (!this.selectedPaint) {
                return '/images/tco/image-coming-soon@1x.webp, /images/tco/image-coming-soon@2x.webp 2x';
            }
            return 'https://cdn.imagin.studio/getImage?customer=robinsandday&zoomType=fullscreen&steering=right&width=800&angle=01&fileType=png&' + this.selectedPaint.url_identifier;

        }
    },
    methods: {
        calculateFinance() {
            // to be replaced with debounced function
            // we have to do it this way as if we put the debounce here, all components share the same debounce call, so only the last component calls the function
        },
        appendVehiclePricingIncludingApplicableGrants(outputArray) {
            const retailPrice = parseFloat(this.selectedVehicle.pricing_display_price);
            const cashPrice = parseFloat((this.quote.Quote?.CashPrice || retailPrice));

            if (retailPrice !== cashPrice) {
                outputArray.push({
                    title: 'Vehicle Price (OTR)',
                    value: '&pound;' + NumberFormat(retailPrice, 2)
                });

                if (this.governmentGrant > 0) {
                    outputArray.push({
                        title: 'Government Grant',
                        value: '&pound;' + NumberFormat(this.governmentGrant, 2)
                    });
                }

                outputArray.push({
                    title: 'Vehicle Selling Price',
                    value: '&pound;' + NumberFormat(cashPrice, 2)
                });
            } else if (this.governmentGrant > 0 && retailPrice == cashPrice) {
                outputArray.push({
                    title: 'Vehicle Price (OTR)',
                    value: '&pound;' + NumberFormat(retailPrice + this.governmentGrant, 2)
                });

                outputArray.push({
                    title: 'Government Grant',
                    value: '&pound;' + NumberFormat(this.governmentGrant, 2)
                });

                outputArray.push({
                    title: 'Vehicle Selling Price',
                    value: '&pound;' + NumberFormat(cashPrice, 2)
                });
            } else {
                outputArray.push({
                    title: 'Vehicle Price',
                    value: '&pound;' + NumberFormat(cashPrice, 2)
                });
            }
            return outputArray;
        },
        setSelectedPaint(paint) {
            if (this.isElectric) {
                this.$store.commit('setSelectedEvPaint', paint);
                return;
            }
            this.$store.commit('setSelectedIcePaint', paint);
        },
        setupColourPickerSwiper() {
            try {
                this.$nextTick(() => {
                    const colourPickerSwiper = new Swiper(this.$refs["colorPicker"], {
                        modules: [Navigation],
                        grabCursor: true,
                        slidesPerView: "auto",
                        spaceBetween: 5,
                        speed: 400,
                        centerInsufficientSlides: true,
                        direction: "horizontal",
                        navigation: {
                            prevEl: this.$refs['swiper-prev'],
                            nextEl: this.$refs['swiper-next'],
                        },
                        breakpoints: {
                            // when window width is >= 640px
                            768: {
                                spaceBetween: 10,
                            }
                        },
                        on: {
                            slideChange: () => {
                                if (colourPickerSwiper.isBeginning) {
                                    this.$refs['swiper-prev'].classList.add('tco-tool__swiper-btn--disabled');
                                    this.$refs['swiper-next'].classList.remove('tco-tool__swiper-btn--disabled');
                                    return;
                                }

                                if (colourPickerSwiper.isEnd) {
                                    this.$refs['swiper-prev'].classList.remove('tco-tool__swiper-btn--disabled');
                                    this.$refs['swiper-next'].classList.add('tco-tool__swiper-btn--disabled');
                                    return;
                                }

                                this.$refs['swiper-prev'].classList.remove('tco-tool__swiper-btn--disabled');
                                this.$refs['swiper-next'].classList.remove('tco-tool__swiper-btn--disabled');
                            },
                        }
                    });
                    if (colourPickerSwiper.isBeginning) {
                        if (this.$refs['swiper-prev']) {
                            this.$refs['swiper-prev'].classList.add('new-details__swiper-btn--disabled');
                        }
                        if (this.$refs['swiper-next']) {
                            this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                        }
                        return;
                    } else if (colourPickerSwiper.isEnd) {
                        if (this.$refs['swiper-prev']) {
                            this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                        }
                        if (this.$refs['swiper-next']) {
                            this.$refs['swiper-next'].classList.add('new-details__swiper-btn--disabled');
                        }
                        return;
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        setupFuelCostSlider() {
            if (!this.isElectric) {
                return;
            }
            if (this.fuelCostSlider) {
                return;
            }
            if (!this.$refs['fuel-cost-slider']) {
                return;
            }
            this.fuelCostSlider = noUiSlider.create(this.$refs['fuel-cost-slider'], {
                start: [this.percentChargedAtHome],
                connect: 'lower',
                range: {
                    'min': 0,
                    'max': 100
                },
                step: 5,
            });
            this.fuelCostSlider.on('update', values => {
                this.percentChargedAtHome = parseInt(values[0]);
                this.debouncedFuelCostSliderEvent();
            });
        },
        togglePersonalFuelUsage() {
            customEvent('TCO', 'Clicked', 'Personalise CTA');
            this.showPersonaliseFuelUsage = !this.showPersonaliseFuelUsage;
            // this.$nextTick(() => {
                this.$emit('match-height-fuel');
            // });
        },
        customEvent() {
            customEvent(...arguments);
        },
        debouncedFuelCostSliderEvent() {
            // to be replaced with debounced function
            // we have to do it this way as if we put the debounce here, all components share the same debounce call, so only the last component calls the function
        }
    },
    created() {
        this.debouncedFuelCostSliderEvent = debounce(() => {
            customEvent('TCO', 'Home Charging Percent', this.percentChargedAtHome + '%');
        }, 500, {
            leading: false,
            trailing: true
        });
        this.calculateFinance = debounce(function () {
            if (!this.selectedVehicle) {
                return;
            }
            let cashPrice = this.selectedVehicle.pricing_display_price;
            if (this.selectedVehicle.price_PCP > 0) {
                cashPrice = this.selectedVehicle.price_PCP;
            }

            if (this.selectedVehicle.titre_code == '1PPDSYTEUFT0A0B0') {
                if (state.selectedTerm == 37 && state.selectedDeposit >= 15100) {
                    cashPrice = 49650;
                }
            }

            let identifier = (this.selectedVehicle.titre_code) ? this.selectedVehicle.titre_code : this.selectedVehicle.cap_id;
            let identifierType = 'Titre';

            if (!this.selectedVehicle.titre_code) {
                if (this.selectedVehicle.type == 'car') {
                    identifierType = 'CapCarShortCode';
                } else {
                    identifierType = 'CapLcvShortCode';
                }
            }

            const request = {
                "Credentials": {
                    "ApiKey": "ONH75GHd8x0gu6yfJ6"
                },
                "Customer": {
                    "Reference": ''
                },
                "Parameters": {
                    "Term": this.term,
                    "Deposit": this.deposit,
                    "DepositType": "Amount",
                    "AnnualMileage": this.mileage,
                    "IsTelematics": false,
                },
                "VehicleRequests": [
                    {
                        "Id": this.selectedVehicle.id,
                        "Vehicle": {
                            "CashPrice": cashPrice,
                            "RegistrationDate": format(new Date, 'dd/MM/yyyy'),
                            "IsNew": true,
                            "Identifier": identifier,
                            "IdentifierType": identifierType,
                            "Type": (this.selectedVehicle.type == 'car') ? 'Car' : 'Lcv',
                            "DealerVehicleUrl": window.location.href,
                        },
                        "Products": [{ "Key": "PCP" }]
                    }
                ]
            };

            this.financeLoading = true;
            this.quote
            axios.post('https://services.codeweavers.net/public/v3/JsonFinance/Calculate', request)
                .then(response => {
                    if (typeof response.data['VehicleResults'] == 'undefined') {
                        this.quote = null;
                        this.financeLoading = false;
                        return;
                    }
                    if (typeof response.data['VehicleResults'][0] == 'undefined') {
                        this.quote = null;
                        this.financeLoading = false;
                        return;
                    }
                    if (typeof response.data['VehicleResults'][0]['FinanceProductResults'] == 'undefined') {
                        this.quote = null;
                        this.financeLoading = false;
                        return;
                    }
                    if (typeof response.data['VehicleResults'][0]['FinanceProductResults'].length == 0) {
                        this.quote = null;
                        this.financeLoading = false;
                        return;
                    }

                    response.data['VehicleResults'][0]['FinanceProductResults'].forEach(productResult => {
                        if (typeof productResult.Quote == 'undefined') {
                            return;
                        }

                        if (productResult.Key == 'PCP') {
                            // dispatch('setupActiveQuote', productResult);
                            this.quote = productResult;
                            this.monthlyPayment = productResult.Quote.AllInclusiveRegularPayment;
                            this.apr = productResult.Quote.Apr;
                            this.$nextTick(() => {
                                this.$emit('match-height');
                            });
                            return;
                        }
                    });
                    this.financeLoading = false;
                })
                .catch(error => {
                    console.error(error);
                    this.quote = null;
                    this.financeLoading = false;
                })
        },
            350,
            {
                leading: false,
                trailing: true
            }
        );
    }
}
</script>
